// extracted by mini-css-extract-plugin
export var blogPost = "index-module--blog-post--06fcc";